import {
  FETCH_PACKAGE_ORDER_DETAIL_PENDING,
  FETCH_PACKAGE_ORDER_DETAIL_REJECTED,
  FETCH_PACKAGE_ORDER_DETAIL_FULFILLED,
  SET_PACKAGE_ORDER_DETAIL_SELECTED_IDS,
} from '../constants/packageOrderDetail';

const initialState = {
  pending: true,
  packageOrderDetail: {
    stockLocation: {},
    state: {},
    shippingAddress: {}
  },
  selectedIds: {},
  error: {},
};

export const packageOrderDetail = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PACKAGE_ORDER_DETAIL_PENDING:
      return { ...state, pending: true, error: {} };

    case FETCH_PACKAGE_ORDER_DETAIL_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_PACKAGE_ORDER_DETAIL_FULFILLED:
      return {
        ...state,
        packageOrderDetail: action.data,
        pending: false,
        error: {}
      };

    case SET_PACKAGE_ORDER_DETAIL_SELECTED_IDS:
      return {
        ...state,
        selectedIds: action.data,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/packageOrderDetail.js